__turbopack_context__.v({
  "aspectBox": "Overlay-module-scss-module__nEkd_G__aspectBox",
  "bodyCopy": "Overlay-module-scss-module__nEkd_G__bodyCopy",
  "bodyCopyWrapper": "Overlay-module-scss-module__nEkd_G__bodyCopyWrapper",
  "closeButton": "Overlay-module-scss-module__nEkd_G__closeButton",
  "closeIconWrapper": "Overlay-module-scss-module__nEkd_G__closeIconWrapper",
  "content": "Overlay-module-scss-module__nEkd_G__content",
  "cta": "Overlay-module-scss-module__nEkd_G__cta",
  "fade-in": "Overlay-module-scss-module__nEkd_G__fade-in",
  "hasImage": "Overlay-module-scss-module__nEkd_G__hasImage",
  "headline": "Overlay-module-scss-module__nEkd_G__headline",
  "headlineWrapper": "Overlay-module-scss-module__nEkd_G__headlineWrapper",
  "icon": "Overlay-module-scss-module__nEkd_G__icon",
  "iconWrapper": "Overlay-module-scss-module__nEkd_G__iconWrapper",
  "image": "Overlay-module-scss-module__nEkd_G__image",
  "imageAspectBox": "Overlay-module-scss-module__nEkd_G__imageAspectBox",
  "imageLarge": "Overlay-module-scss-module__nEkd_G__imageLarge",
  "imageSmall": "Overlay-module-scss-module__nEkd_G__imageSmall",
  "innerContent": "Overlay-module-scss-module__nEkd_G__innerContent",
  "isVisible": "Overlay-module-scss-module__nEkd_G__isVisible",
  "overlay": "Overlay-module-scss-module__nEkd_G__overlay",
  "overlayInner": "Overlay-module-scss-module__nEkd_G__overlayInner",
  "root": "Overlay-module-scss-module__nEkd_G__root",
});
